export const candidateListScrollKey = (pathname: string) =>
  `di-hr:scroll:candidate-list:${pathname}`;

export const PIPELINE_SCROLL_STORAGE_KEY = 'di-hr:scroll:pipeline';

export type CandidateListScrollSnapshot = {
  v: 1;
  scrollTop: number;
  scrollLeft: number;
  currentPage: number;
  interviewDayFilter?: string;
  search: string;
  roleFilters: string[];
  sortDirection?: 'asc' | 'desc';
  sortKey?: string;
  stageFilters: string[];
  teamFilters?: string[];
};

export type PipelineScrollSnapshot = {
  v: 1;
  board: { scrollLeft: number; scrollTop: number };
  /** Per-column vertical scroll (pipeline stage keys). */
  columns: Record<string, number>;
  visibleByStage: Record<string, number>;
};

export function parseCandidateListScrollSnapshot(
  raw: string | null,
): CandidateListScrollSnapshot | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as CandidateListScrollSnapshot;
    if (parsed?.v !== 1) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function parsePipelineScrollSnapshot(raw: string | null): PipelineScrollSnapshot | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as PipelineScrollSnapshot;
    if (parsed?.v !== 1) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function applyScrollAfterPaint(setScroll: () => void): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(setScroll);
  });
}
